/**
 * 유종별 색상 및 라벨 공통 상수
 * globals.css의 유종별 색상과 일치하도록 관리
 */

/** 유종별 색상 (primary/light/border/text 변형 포함) */
export const FUEL_COLORS = {
  premiumGas: {
    // 1001: 고급무연
    primary: '#ff0000',
    light: '#ffcccc',
    border: '#ff9999',
    text: '#cc0000',
  },
  gas: {
    // 1003: 무연
    primary: '#ffff00',
    light: '#fff9cc',
    border: '#ffeb99',
    text: '#ccaa00',
  },
  diesel: {
    // 1004: 경유
    primary: '#80ff00',
    light: '#ccffcc',
    border: '#99ff99',
    text: '#006600',
  },
  kerosene: {
    // 1006: 등유
    primary: '#945200',
    light: '#f4e4c1',
    border: '#e6d4a3',
    text: '#945200',
  },
  lpg: {
    // 1007/1008: 부탄/프로판 (station-map-view에서 #14b8a6 → 통일)
    primary: '#8b1a1a',
    light: '#f8d7d7',
    border: '#e8a5a5',
    text: '#6b1515',
  },
} as const;

export type FuelType = keyof typeof FUEL_COLORS;

/** 유종 코드 (globals.css 기준) */
export const OIL_CODES = {
  1001: 'premiumGas',   // 고급무연
  1002: 'premiumDiesel', // 고급경유
  1003: 'gas',           // 무연
  1004: 'diesel',        // 경유
  1005: 'urea',          // 요소수
  1006: 'kerosene',      // 등유
  1007: 'butane',        // 부탄 (LPG)
  1008: 'propane',       // 프로판 (LPG)
} as const;

export type OilCode = keyof typeof OIL_CODES;

/** 유종 코드 → 색상 매핑 (globals.css .oil-XXXX-color와 일치) */
export const OIL_CODE_COLORS: Record<OilCode, string> = {
  1001: FUEL_COLORS.premiumGas.primary, // #ff0000
  1002: '#ffffff',
  1003: FUEL_COLORS.gas.primary,        // #ffff00
  1004: FUEL_COLORS.diesel.primary,     // #80ff00
  1005: '#f4c473',
  1006: '#f4c473',
  1007: FUEL_COLORS.lpg.primary,        // #8b1a1a
  1008: FUEL_COLORS.lpg.primary,        // #8b1a1a
};

/** 유종 한글 라벨 */
export const FUEL_LABELS: Record<FuelType, string> = {
  premiumGas: '고급휘발유',
  gas: '휘발유',
  diesel: '경유',
  kerosene: '등유',
  lpg: 'LPG',
};

/**
 * 유종 한글명 → 색상 매핑 (차트에서 한글명으로 색상 조회 시 사용)
 * globals.css의 .oil-XXXX-color 클래스와 동일한 값을 사용
 * FUEL_COLORS.primary와 다를 수 있음 (등유, 부탄, 프로판)
 */
export const OIL_NAME_COLORS: Record<string, string> = {
  고급무연: FUEL_COLORS.premiumGas.primary,
  고급경유: '#ffffff',
  무연: FUEL_COLORS.gas.primary,
  경유: FUEL_COLORS.diesel.primary,
  요소수: '#f4c473',
  등유: '#f4c473',
  부탄: '#f4c473',
  프로판: '#f4c473',
};
